import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { EsriMapComponent } from './components/esri-map/esri-map.component';
import { IEsriMapOptions } from './interfaces';
import { ESRI_MODULES_TOKEN, esriModulesFactory } from './tokens';

@NgModule({
  imports: [CommonModule],
  declarations: [EsriMapComponent],
  exports: [EsriMapComponent],
  providers: [
    {
      provide: ESRI_MODULES_TOKEN,
      useFactory: esriModulesFactory,
    },
  ],
})
export class EsriModule {
  public static forChild(defaultOptions: IEsriMapOptions): ModuleWithProviders<EsriModule> {
    return {
      ngModule: EsriModule,
    };
  }
}
